import React, { useEffect, useState } from "react";
import DetailedButton from "../detailedView/DetailedButton";
import { getAllObjects } from "../firebase/playerFuncs";
import useHandlePlayerArrays from "../hooks/useHandlePlayerArrays";
import InnerListBox from "./InnerListBox";
import collectionStore from "./../stores/collectionStore";
import useHandleBoxTypes from "../hooks/useHandleBoxTypes";
import SideButton from "./../detailedView/SideButtons";
import { openCounters, savedCounters } from "./displayedCounters";
import useHover from "../hooks/useHover";
import MainStore from "../stores/MainStore";
import boxStore from "./../stores/boxStore";

const BoxListHolder = ({ box }) => {
  const [objects, setObjects] = useState(null);
  const [boxType, setBoxType] = useState(null);
  const { getObject } = useHandlePlayerArrays();
  const { getPluralType, getBoxType } = useHandleBoxTypes();
  const { addGeneralObjects } = collectionStore();
  const { setDetailedView } = MainStore();
  const { resetBoxTypeOverview } = boxStore();
  const hover = useHover();

  function onOpenClicked(object) {
    resetBoxTypeOverview();
  }

  function onObjectsReceived(objs) {
    setObjects(objs);
  }

  function openDetailedView() {
    resetBoxTypeOverview();
    setDetailedView(objects);
  }
  useEffect(() => {
    getAllObjects(
      getObject,
      box.type,
      null,
      box.id,
      addGeneralObjects,
      getPluralType,
      onObjectsReceived
    );

    // setBoxType of the box
    setBoxType(getBoxType(box.type));
  }, [box]);
  return (
    <div className="divRow" style={{ width: "100%", cursor: "pointer" }}>
      {box.collection == "saved" && (
        <SideButton
          description={`Open ${box.type}`}
          type={box.type}
          onButtonClicked={onOpenClicked}
          name={"Open"}
          fontSize={"15px"}
          backgroundColor={"#6f6f6f"}
          image={"/icons/icon_save.png"}
          width={"100px"}
          object={objects?.open}
        />
      )}
      <div
        {...hover.divProps}
        className="divRow"
        style={{
          marginLeft: "5px",
          marginTop: "5px",
          padding: "5px",
          flex: 1,
          border: "3px solid #1f1f1f",
          borderRadius: ".5rem/.5rem",
          backgroundColor: hover.hover ? "#5f5f5f" : null,
        }}
      >
        <img className="icon40" src={box.image ?? "/icons/icon_box.png"} />
        <div
          onClick={openDetailedView}
          className="textBold"
          style={{
            flex: 1,
            textAlign: "center",
            fontSize: "20px",
            color: hover.hover ? "white" : null,
          }}
        >
          {box.shortDescription}
        </div>
        <InnerListBox box={box} />
        <BoxTypeButton boxType={boxType} />
      </div>
    </div>
  );
};

const BoxTypeButton = ({ boxType }) => {
  return (
    <div
      className="textBoldWhite"
      style={{
        padding: "5px",
        borderRadius: "10px",
        color: boxType?.colors.text,
        backgroundColor: boxType?.colors.primary,
      }}
    >
      {boxType?.names.singular}
    </div>
  );
};

export default BoxListHolder;
